var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    "data-name": "Layer 1",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m363.13 368.539c-15.519-10.581-28.63-35.375-28.63-54.143v-84.1l77.731-38.07-9.985-4.905-87.746 42.971v84.1c0 18.768 13.111 43.562 28.63 54.143l59.12 40.32 10-6.82z",
    fill: "#d4e1f4",
    "data-original": "#D4E1F4"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0635c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.185 242.132a24.749 24.749 0 0 0 .177 49.5h.187a24.749 24.749 0 0 0 -.18-49.5zm12.929 24.654a12.762 12.762 0 0 1 -12.653 12.842h-.1a12.749 12.749 0 0 1 -.093-25.5h.1a12.764 12.764 0 0 1 12.746 12.658z",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.24 190.138a66.22 66.22 0 0 0 -3.313-16.057c-3.817-11.173-15.612-18.352-30.107-18.352h-.32c-9.089.067-25.681.13-32.922.155l-14.994-27.159c-10.272-18.1-25.182-38.848-49.589-38.848h-.317l-180.078 1.329c-20.059.148-37.781 14.214-49.915 39.609l-15.247 27.49c-7.216.038-24 .13-33.2.2-14.642.108-26.479 7.486-30.158 18.8a66.371 66.371 0 0 0 -3.076 16.1 6 6 0 0 0 5.996 6.244h.052l24.5-.212c-10.525 7.374-17.334 20.366-17.223 35.421a5.918 5.918 0 0 0 .054.753l11.19 83.462a24.126 24.126 0 0 0 20.664 23.262l.2 27.222a15.062 15.062 0 0 0 15.043 14.934h.112l27.465-.2a15.063 15.063 0 0 0 14.934-15.156l-.2-26.95 199.448-1.469a6 6 0 1 0 -.088-12l-253.408 1.864h-.091a12.1 12.1 0 0 1 -12.088-12 6.135 6.135 0 0 0 -.052-.754l-11.186-83.421c.035-17.725 12.127-28.624 24.3-29.4a5.974 5.974 0 0 0 1.047.1h.044l307.595-2.239-.088-12-9.92.072a43.5 43.5 0 0 0 -43.195-38.449h-.33a43.56 43.56 0 0 0 -42.951 39.077l-200.928 1.468 31.371-56.56c.06-.109.117-.22.17-.332 5.823-12.235 18.664-32.784 39.248-32.936l180.075-1.327h.236c14.4 0 26.124 9.819 39.112 32.708l28.911 52.367 10.5-5.8-7.337-13.292c8.191-.031 19.466-.08 26.4-.131 9.215-.078 16.872 4.042 18.986 10.23a53.99 53.99 0 0 1 1.771 6.564l-17.725.137a6 6 0 0 0 .045 12h.047l24.587-.19a6 6 0 0 0 5.944-6.333zm-352.25 179.082a3.049 3.049 0 0 1 -3.022 3.068l-27.473.2h-.015a3.048 3.048 0 0 1 -3.044-3.022l-.2-26.95 33.554-.247zm213.873-204.726a31.509 31.509 0 0 1 31.345 26.536l-62.29.453a31.548 31.548 0 0 1 30.945-26.989zm-290.37 16.517c2.022-6.217 9.591-10.44 18.834-10.508 6.951-.052 18.228-.116 26.437-.162l-9.387 16.923-37.556.326a54.107 54.107 0 0 1 1.672-6.579z",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.147 244.231h-.047a6 6 0 0 0 -5.957 6.044l.127 17.277a6 6 0 0 0 6 5.956h.045a6 6 0 0 0 5.956-6.044l-.127-17.276a6 6 0 0 0 -5.997-5.957z",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.1 244.467a6 6 0 0 0 -5.957 6.044l.128 17.277a6 6 0 0 0 6 5.956h.045a6 6 0 0 0 5.956-6.045l-.128-17.277a6.031 6.031 0 0 0 -6.044-5.955z",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.147 244h-.047a6 6 0 0 0 -5.957 6.044l.127 17.276a6 6 0 0 0 6 5.956h.045a6 6 0 0 0 5.956-6.044l-.127-17.276a6 6 0 0 0 -5.997-5.956z",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.146 243.76h-.046a6 6 0 0 0 -5.956 6.044l.127 17.277a6 6 0 0 0 6 5.955h.045a6 6 0 0 0 5.956-6.044l-.127-17.277a6 6 0 0 0 -5.999-5.955z",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.146 243.524h-.046a6 6 0 0 0 -5.956 6.044l.126 17.276a6 6 0 0 0 6 5.956h.045a6 6 0 0 0 5.956-6.044l-.126-17.276a6 6 0 0 0 -5.999-5.956z",
    "data-original": "#0635C9",
    className: "",
    style: {
      fill: "#2F55D4"
    },
    "data-old_color": "#0635C9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m498.646 221.3-93.746-46.05a5.994 5.994 0 0 0 -5.285 0l-93.75 45.915a6 6 0 0 0 -3.361 5.388v87.847c0 22.971 14.878 51.108 33.869 64.057l62.5 42.626a6 6 0 0 0 6.762 0l62.5-42.625c18.987-12.958 33.865-41.091 33.865-64.058v-87.719a6 6 0 0 0 -3.354-5.381zm-8.646 93.1c0 18.768-13.111 43.562-28.631 54.143l-59.119 40.32-59.12-40.32c-15.519-10.581-28.63-35.375-28.63-54.143v-84.1l87.746-42.975 87.754 43.094z",
    fill: "#1ae5be",
    "data-original": "#1AE5BE",
    className: "hovered-path active-path",
    style: {
      fill: "#2ECA8B"
    },
    "data-old_color": "#1ae5be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.428 289.924a6 6 0 0 0 -8.823 8.135l20.206 21.91a6 6 0 0 0 8.463.357l38.262-35.046a6 6 0 0 0 -8.105-8.849l-33.852 31.007z",
    fill: "#1ae5be",
    "data-original": "#1AE5BE",
    className: "hovered-path active-path",
    style: {
      fill: "#2ECA8B"
    },
    "data-old_color": "#1ae5be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.308ab623d54aa8cb008267a0793e09e0.svg";
export { ForwardRef as ReactComponent };